module.exports = {"623023100":"城关镇","623023101":"大川镇","623023102":"峰迭镇","623023103":"立节镇","623023104":"东山镇","623023105":"曲告纳镇","623023106":"博峪镇","623023107":"巴藏镇","623023108":"憨班镇","623023109":"坪定镇","623023110":"果耶镇","623023111":"武坪镇","623023112":"大峪镇","623023113":"江盘镇","623023114":"拱坝镇","623023200":"曲瓦乡","623023208":"南峪乡","623023210":"八楞乡","623023212":"插岗乡","623023400":"舟曲县林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/623023.json
// module id = 2974
// module chunks = 0